export function linkToAnonymousWhatIsPremium() {
  return "/what-is-premium";
}
